import kt from "./auth-manager.js";
import y from "../common/base-provider.js";
import ot from "../util/browser-detector.js";
import Ot from "./device-manager.js";
import DeviceProperties from "../Core/device-properties.js";
import {
  isArray as p,
  keys as or,
  validateValueIsFromEnum as F,
  values as Lt
} from "../util/code-utils.js";
import { logDeprecationWarning as D } from "../util/deprecation-utils.js";
import Pt from "./network-manager.js";
import Rt from "../request-controller.js";
import Mt from "./server-config-manager.js";
import jt from "./session-manager.js";
import r from "../../shared-lib/braze-shared-lib.js";
import G, { STORAGE_KEYS as o } from "./storage-manager.js";
import Dt from "./storage-manager-factory.js";
import u from "./subscription-manager.js";
import { TriggersProviderFactory as W } from "../triggers/triggers-provider-factory.js";
import bt from "../User/user-manager.js";
import { User } from "../User/index.js";
import { parseQueryStringKeyValues as ut } from "../util/url-utils.js";
import { WindowUtils as H } from "../util/window-utils.js";
const T = {
  Yn: "allowCrawlerActivity",
  Xn: "baseUrl",
  Zn: "noCookies",
  ho: "devicePropertyAllowlist",
  ta: "disablePushTokenMaintenance",
  po: "enableLogging",
  Eo: "enableSdkAuthentication",
  ia: "manageServiceWorkerExternally",
  _o: "minimumIntervalBetweenTriggerActionsInSeconds",
  Io: "sessionTimeoutInSeconds",
  Ao: "appVersion",
  na: "serviceWorkerLocation",
  ra: "safariWebsitePushId",
  jn: "localization",
  ao: "contentSecurityNonce",
  So: "enableHtmlInAppMessages",
  No: "allowUserSuppliedJavascript",
  no: "inAppMessageZIndex",
  lo: "openInAppMessagesInNewTab",
  tn: "openCardsInNewTab",
  en: "openNewsFeedCardsInNewTab",
  Ih: "requireExplicitInAppMessageDismissal",
  wo: "doNotLoadFontAwesome",
  To: "sdkFlavor"
};
class Bt {
  constructor() {
    (this.Oo = !1),
      (this.vo = !1),
      (this.Co = new u()),
      (this.Lo = new u()),
      (this.Po = {}),
      (this.Ro = []),
      (this.Mo = []),
      (this.Se = []),
      (this.jo = "4.7.0");
  }
  yo(t) {
    this.Co.ut(t);
  }
  _h(t) {
    this.Lo.ut(t);
  }
  initialize(t, i) {
    if (this.Do())
      return (
        r.D.info("Braze has already been initialized with an API key."), !0
      );
    this.Po = i || {};
    let s = this.nn(T.po);
    const e = ut(H.bn());
    if (
      (e && "true" === e.brazeLogging && (s = !0),
      r.D.init(s),
      r.D.info(`Initialization Options: ${JSON.stringify(this.Po, null, 2)}`),
      null == t || "" === t || "string" != typeof t)
    )
      return r.D.error("Braze requires a valid API key to be initialized."), !1;
    this._r = t;
    let n = this.nn(T.Xn);
    if (null == n || "" === n || "string" != typeof n)
      return r.D.error("Braze requires a valid baseUrl to be initialized."), !1;
    !1 === /^https?:/.test(n) && (n = `https://${n}`);
    let a = n;
    if (
      ((n = document.createElement("a")),
      (n.href = a),
      "/" === n.pathname && (n = `${n}api/v3`),
      (this.Uo = n.toString()),
      ot.zo && !this.nn(T.Yn))
    )
      return (
        r.D.info("Ignoring activity from crawler bot " + navigator.userAgent),
        (this.vo = !0),
        !1
      );
    const h = this.nn(Bt.Zn) || !1;
    if (((this.h = Dt.Bo(t, h)), new G.ne(null, !0).lr(o.ae)))
      return (
        r.D.info("Ignoring all activity due to previous opt out"),
        (this.vo = !0),
        !1
      );
    for (const t of or(this.Po))
      -1 === Lt(r.Wo).indexOf(t) &&
        r.D.warn(`Ignoring unknown initialization option '${t}'.`);
    const l = ["mparticle", "wordpress", "tealium"];
    if (null != this.nn(T.To)) {
      const t = this.nn(T.To);
      -1 !== l.indexOf(t)
        ? (this.Fo = t)
        : r.D.error("Invalid sdk flavor passed: " + t);
    }
    let f = this.nn(r.Wo.ho);
    if (null != f)
      if (p(f)) {
        const t = [];
        for (let i = 0; i < f.length; i++)
          F(
            DeviceProperties,
            f[i],
            "devicePropertyAllowlist contained an invalid value.",
            "DeviceProperties"
          ) && t.push(f[i]);
        f = t;
      } else
        r.D.error(
          "devicePropertyAllowlist must be an array. Defaulting to all properties."
        ),
          (f = null);
    (this.Ur = new Ot(this.h, f)),
      (this.gt = new Mt(this.h)),
      (this.v = new bt(this.gt, this.h)),
      (this.j = new jt(this.h, this.v, this.gt, this.nn(T.Io)));
    const m = new u();
    return (
      (this.Vo = new kt(this.h, this.nn(T.Eo), m)),
      this.jt(m),
      (this.vt = new Pt(
        this.Ur,
        this.h,
        this.Vo,
        this.v,
        this.j,
        this.gt,
        this._r,
        this.Uo,
        this.jo,
        this.Fo,
        this.nn(T.Ao)
      )),
      (this.Ci = new Rt(
        this._r,
        this.Uo,
        this.j,
        this.Ur,
        this.v,
        this.gt,
        this.h,
        t => {
          if (this.Do()) for (const i of this.re()) i.Rs(t);
        },
        this.Vo,
        this.vt
      )),
      this.Ci.initialize(),
      r.D.info(
        `Initialized for the Braze backend at "${this.nn(
          T.Xn
        )}" with API key "${this._r}".`
      ),
      null != this.nn(T.So) &&
        D(
          "enableHtmlInAppMessages",
          "initialization option",
          "allowUserSuppliedJavascript"
        ),
      W.init(),
      this.gt.Fi(() => {
        this.Oo &&
          this.gt.ci() &&
          import("../FeatureFlags/refresh-feature-flags.js").then(t => {
            if (!this.Oo) return;
            (0, t.default)();
          });
      }),
      this.Ci.cr(() => {
        this.Oo &&
          this.gt.ci() &&
          import("../FeatureFlags/refresh-feature-flags.js").then(t => {
            if (!this.Oo) return;
            (0, t.default)(null, null, !0);
          });
      }),
      this.Co.St(this.Po),
      (this.Oo = !0),
      !0
    );
  }
  destroy(t) {
    if ((r.D.destroy(), this.Do())) {
      this.Lo.St(), this.Lo.removeAllSubscriptions();
      for (const t of this.Ro) t.destroy();
      this.Ro = [];
      for (const t of this.Mo) t.clearData(!1);
      (this.Mo = []),
        this.removeAllSubscriptions(),
        (this.Se = []),
        this.Ci.destroy(),
        (this.Ci = null),
        (this.Vo = null),
        (this.Ur = null),
        (this.vt = null),
        (this.gt = null),
        (this.j = null),
        (this.v = null),
        (this.Po = {}),
        (this.Fo = void 0),
        (this.Oo = !1),
        (this.vo = !1),
        t && (this.h = null);
    }
  }
  rr() {
    if (this.Go()) return !1;
    if (!this.Do())
      throw new Error("Braze must be initialized before calling methods.");
    return !0;
  }
  ea() {
    return this._r;
  }
  ii() {
    return this.Vo;
  }
  Ks() {
    return this.Uo;
  }
  ce() {
    return this.Ur;
  }
  nr() {
    return this.vt;
  }
  nn(t) {
    return this.Po[t];
  }
  re() {
    return this.Mo;
  }
  mr() {
    return this.Ci;
  }
  ir() {
    return this.gt;
  }
  g() {
    return this.j;
  }
  l() {
    return this.h;
  }
  gr() {
    if (this.v && this.Ci) return new User(this.v, this.Ci);
  }
  p() {
    return this.v;
  }
  tr() {
    return !0 === this.nn(T.No) || !0 === this.nn(T.So);
  }
  u(t) {
    let i = !1;
    for (const s of this.Ro) s === t && (i = !0);
    i || this.Ro.push(t);
  }
  ar(t) {
    let i = !1;
    for (const s of this.Mo) s.constructor === t.constructor && (i = !0);
    t instanceof y && !i && this.Mo.push(t);
  }
  jt(t) {
    t instanceof u && this.Se.push(t);
  }
  removeAllSubscriptions() {
    if (this.rr()) for (const t of this.Se) t.removeAllSubscriptions();
  }
  removeSubscription(t) {
    if (this.rr()) for (const i of this.Se) i.removeSubscription(t);
  }
  le(t) {
    this.vo = t;
  }
  Do() {
    return this.Oo;
  }
  Go() {
    return this.vo;
  }
  Ds() {
    return this.jo;
  }
}
const e = new Bt();
export { e as default, Bt as BrazeSdkInstance, T as OPTIONS };
